export default __webpack_public_path__ + "static/media/schulte-letters.4fbb23eb.svg";